'use client';

import { useAccount, useSwitchChain } from 'wagmi';
import { useConnectModal } from '@rainbow-me/rainbowkit';
import { Button } from './PrimaryButton';
import { WriteButton, type Props as WriteButtonProps } from './WriteButton';

export function ConnectedWriteButton({ write, label, className }: WriteButtonProps) {
  const { openConnectModal } = useConnectModal();
  const { chain, address, isConnecting } = useAccount();
  const { switchChain, isPending: isSwitchingNetwork } = useSwitchChain();

  if (!address) {
    if (openConnectModal) {
      return (
        <Button
          className={className}
          pending={isConnecting}
          label={label}
          labelHover="Connect wallet"
          onClick={openConnectModal}
        />
      );
    } else {
      return <Button className={className} label="Cannot connect wallet" disabled />;
    }
  }

  if (chain != null && write.chainId != null && chain.id !== write.chainId) {
    if (switchChain) {
      return (
        <Button
          className={className}
          pending={isSwitchingNetwork}
          label={label}
          labelHover="Switch network"
          onClick={() =>
            switchChain({
              chainId: write.chainId,
            })
          }
        />
      );
    } else {
      return <Button className={className} label="Wrong network" disabled />;
    }
  }

  return <WriteButton className={className} write={write} label={label} />;
}
